export const PAYMENT_METHODS = {
  credit_card: 'CREDIT_CARD',
  pix: 'PIX',
  boleto: 'BOLETO',
} as const

export type PaymentMethod = keyof typeof PAYMENT_METHODS;

export type ApiPaymentMethod = typeof PAYMENT_METHODS[PaymentMethod];

export const getDefaultPaymentMethod = (
  allowedMethods: ApiPaymentMethod[],
): PaymentMethod | undefined =>
  (Object.keys(PAYMENT_METHODS) as PaymentMethod[]).find(method =>
    allowedMethods.includes(PAYMENT_METHODS[method]),
  );
